module.exports = __webpack_public_path__ + "img/transpornet.fa512614.png";